export default __webpack_public_path__ + "static/media/indtech_fms3.43db1dc4.jpg";